import { render, staticRenderFns } from "./DeviceVendorIcon.vue?vue&type=template&id=1b11aea4&scoped=true&lang=pug&"
import script from "./DeviceVendorIcon.vue?vue&type=script&lang=ts&"
export * from "./DeviceVendorIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceVendorIcon.vue?vue&type=style&index=0&id=1b11aea4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b11aea4",
  null
  
)

component.options.__file = "DeviceVendorIcon.vue"
export default component.exports